/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS, GET_SECTIONS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISectionsMethods extends IPluginMethodMap {
  getSections(args: any): Promise<any>;
}

export class SectionsService implements IAgentPlugin {
  readonly methods: ISectionsMethods;

  constructor() {
    this.methods = {
      getSections: this.getSectionsProps.bind(this),
    };
  }

  async getSectionsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let addOnFilter = {};
    console.log(args);
    try {
      if (client) {
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {
              status: {
                eq: "active",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        const presentations = _res?.data?.getPresentations?.content || [];
        const activePresentationId = args?.id ?? presentations[0]?.id;

        if (!activePresentationId) {
          return {
            searchStatusFilter: [],
            isEmpty: true,
            hasNoPresentations: true,
          };
        }

        addOnFilter = {
          filter: {
            presentation: {
              eq: activePresentationId,
            },
          },
        };
        const res = await client.query({
          query: GET_SECTIONS,
          variables: {
            ...addOnFilter,
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          const sections = res?.data?.getSections?.content || [];
          return {
            searchStatusFilter: sections.map((_item: any) => {
              return { value: _item?.id, label: _item?.name };
            }),
            defaultPresentation: activePresentationId,
            isEmpty: sections.length === 0,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
